<template>
  <el-dialog :append-to-body="true" :visible.sync="dialog" title="编辑内容（编辑完成后请点击保存）"
             :close-on-click-modal="false" :close-on-press-escape="false"
             width="80%" class="mdDialog" :before-close="cancel">
    <mavon-editor ref="md" @imgAdd="imgAdd" v-model="mdValue"  @save="handleSave"/>
  </el-dialog>
</template>

<script>
import { uploadSingleFile } from '@/api/file'
export default {
  name: 'mMavonEditor',
  data () {
    return {
      dialog: false,
      mdValue: ''
    }
  },
  methods: {
    /**
     * @description 上传图片
     */
    imgAdd (pos, $file) {
      let fd = new FormData()
      fd.append('file', $file)
      uploadSingleFile(fd).then(res => {
        let url = res.body
        this.$refs['md'].$img2Url(pos, url)
      })
    },
    /**
     * @description 保存钩子函数
     */
    handleSave (value, render) {
      this.$store.commit('SET_MDVALUE', value)
      this.$store.commit('SET_MDHTML', render)
    },
    cancel () {
      this.$confirm(`确定关闭对话框？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dialog = false
        this.$emit('closeDialog')
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss">
.mdDialog {
  .v-note-wrapper {
    min-height: 500px;
  }
}
</style>
